import React from 'react';
import {
  StyleSheet,
  Image,
  TextInput,
  Animated,
  View
} from 'react-native';

//class FloatingLabel extends PureComponent {
export const FloatingLabel = (props) => {
  const onChangeTextCallback = props.onChangeText;

  const style = props.value || props.placeholder ? dirtyStyle : cleanStyle;

  const [state, setState] = React.useState({
    text: props.value,
    dirty: props.value || props.placeholder,
    labelStyle: {
      fontSize: new Animated.Value(style.fontSize),
      top: new Animated.Value(style.top),
    }
  });

  const onChangeText = (text) => {
    setState({ ...state, text });
    if (onChangeTextCallback) {
      onChangeTextCallback(text);
    }
  };

  const updateText = (event) => {
    const { text } = event.nativeEvent;
    setState({ ...state, text });
    if (props.onEndEditing) {
      props.onEndEditing(event);
    }
  };
 

  const render = () => {
    const {
      container,
      placeholder,
      onChangeText,
      value,
      keyboardType,
      secureTextEntry,
      returnKeyType,
      isSelection,
      autoFocus,
      onSubmitEditing,
      TextInputStyle,
      editable,
      pointerEvents,
      maxLength,
      blurOnSubmit,
      autoCapitalize,
      onTouchStart,
      textAlignVertical,
      multiline,
      numberOfLines,
      dropDownIcon,
      dropDownIconStyle,
      style,
      labelText,
      labelStyle,
      placeholderTextColor,
      onSubmit,
      ref,
    } = props;

    return (
      <View style={[styles.container, container]}>        
        <TextInput
          {...props}          
          onChangeText={onChangeText}
          onEndEditing={updateText}          
          placeholderTextColor={placeholderTextColor}
          placeholder={placeholder}
          underlineColorAndroid={'transparent'}
          value={value}
          keyboardType={keyboardType}
          blurOnSubmit={blurOnSubmit}
          secureTextEntry={secureTextEntry}
          autoCorrect={false}
          returnKeyType={returnKeyType}
          numberOfLines={numberOfLines}
          selection={isSelection ? { start: 0, end: 0 } : undefined}
          autoFocus={autoFocus}
          onSubmitEditing={onSubmit}
          ref={ref}
          editable={editable}
          pointerEvents={pointerEvents}
          autoCapitalize={autoCapitalize}
          maxLength={maxLength}
          onTouchStart={onTouchStart}
          textAlignVertical={textAlignVertical}
          multiline={multiline}
          style={[styles.input, style]}
        />
        <Image
          style={dropDownIconStyle}
          resizeMode="contain"
          source={dropDownIcon}
        />
      </View>
    );
  }

  return render();
}

const labelStyleObj = {
  marginTop: 17,
  paddingLeft: 5,
  color: '#AAA',
  position: 'absolute',
};

const styles = StyleSheet.create({
  container: {
    position: 'relative',
    width: '100%',
    alignItems: 'center',
    // backgroundColor: 'red',
    flexDirection: 'row',
  },
  input: {
    height: 50,
    borderColor: 'gray',
    backgroundColor: 'transparent',
    justifyContent: 'center',
    width: '100%',
    color: 'black',
    fontSize: 20,
    paddingLeft: 10,
    marginTop: 20,
  },
  
});

const cleanStyle = {
  fontSize: 20,
  top: 7,
};

const dirtyStyle = {
  fontSize: 12,
  top: -17,
};


